
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { receivelicensedata, mandant, modules, targetToleranceDefault } from "../typing/generalType";
import { myfetchThunk } from "../../../app/myfetch";
import {actions} from "../actions/Action";
import {masteruri} from '../../../config';
// import { myfetchThunk } from "../../../app/myfetch";


// Interface which is expected from api call
interface testdataResponsePayloadInterface{
    data:receivelicensedata
}

interface ModuleResponseInterface{
    data:
    {
        user:modules[]
    }
    
}

interface MadnantResponseInterface{
    data:
    {
        user:mandant[]
    }
}


export const requestCredCreationFromAPI =(data:any) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        console.log(data)
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/create",
            {data},
            "POST",
            (payload:testdataResponsePayloadInterface) => {
                console.log(payload)
                // dispatch state update action
                //dispatch(loginActions.doLogin({Login:payload.login}));
                // console.log(JSON.parse(payload.toString()))
                
            },
            (payload:any) => {
                console.log("ERROR")
                console.log(payload)
                // dispatch state update action
                //dispatch(loginActions.doLogin({Login:payload.login}));
                // console.log(JSON.parse(payload.toString()))
                
            },
        ) as any)
    }
}

export const requestMandantenFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/Mandants",
            {},
            "GET",
            (payload:MadnantResponseInterface) => {
                console.log(payload)
                // dispatch state update action
                dispatch(actions.SetMandant({data:payload.data.user}));
                // console.log(JSON.parse(payload.toString()))
                
            },
            () => {
                console.log("ERROR")  
            },
        ) as any)
    }
}

export const requestModulesFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/Modules",
            {},
            "GET",
            (payload:ModuleResponseInterface) => {
                console.log(payload)
                // dispatch state update action
                dispatch(actions.SetModules({data:payload.data.user}));
                // console.log(JSON.parse(payload.toString()))
                
            },
            () => {
                console.log("ERROR")  
            },
        ) as any)
    }
}

/**
 * The hub-wide target tolerance, shown as placeholder of the tolerance field.
 * Takes a callback so the licence details can use it as well.
 */
export const requestToleranceDefaultFromAPI =(onLoaded:(percent:number) => void) => {
    return (
        dispatch:Dispatch<any>,
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/License/targettolerance",
            {},
            "GET",
            (payload:targetToleranceDefault) => {
                onLoaded(payload.defaultPercent);
            },
            () => {
                // No default from the hub: the field keeps the plain "default" placeholder.
            },
        ) as any)
    }
}
